import { cost_per_km2_solar, cost_per_km2_wind, cost_per_nuclear_plant } from "../../../data/cost"
import { AggregateBuiltPowerPlant } from "../../../data/power_plants/interface"
import { IGameScore } from "../../interface"
import { SCORE_SHORTAGE_MULTIPLIER } from "../constants"
import { ModelDataInputs, SimulationState } from "../interface"


export function calculate_score(model_state: SimulationState | undefined, data_dependencies: ModelDataInputs): IGameScore
{
    let building_cost = 0

    Object.entries(model_state?.built_power_plants.aggregated_by_h3r4 || {}).forEach(([h3r4_id, cell]) =>
    {
        const initial = data_dependencies.initial_aggregated_power_plants_by_h3r4_id[h3r4_id]

        const wind_area_built_km2 = extra_area_built(initial?.wind, cell.wind)
        const solar_area_built_km2 = extra_area_built(initial?.solar, cell.solar)
        const nuclear_plants_built = cell.nuclear.count - (initial?.nuclear.count ?? 0)

        building_cost += wind_area_built_km2 * cost_per_km2_wind
        building_cost += solar_area_built_km2 * cost_per_km2_solar
        building_cost += nuclear_plants_built * cost_per_nuclear_plant
    })

    // Shortage & excess
    let shortage_TWh = 0
    let excess_TWh = 0
    model_state?.timesteps.forEach(model_state =>
    {
        // Each timepoint is one hour so the shortfall in GWh is the same as the
        // shortfall in GW
        // Also the demand factors in demand from storage like pumped hydro,
        // batteries, compressed air, etc.
        const diff_GWh = (model_state.generated_GW.primary + model_state.generated_GW.storage - model_state.demand_GW)
        const diff_TWh = diff_GWh / 1000
        shortage_TWh += Math.max(0, -diff_TWh)
        excess_TWh += Math.max(0, diff_TWh)
    })

    const total_score = 100
        - building_cost
        - (shortage_TWh * SCORE_SHORTAGE_MULTIPLIER)
        - excess_TWh

    return {
        shortage_TWh,
        excess_TWh,
        building_cost,
        running_cost: 0,
        resilience_score: 0,
        total_score,
    }
}


function extra_area_built(initial_wind_or_solar: AggregateBuiltPowerPlant | undefined, wind_or_solar: AggregateBuiltPowerPlant)
{
    return wind_or_solar.area_km2 - (initial_wind_or_solar?.area_km2 ?? 0)
}
